import { Schema } from "effect";

export const CareNavigationRosterMember = Schema.Struct({
  email: Schema.String,
  name: Schema.String,
  title: Schema.NullOr(Schema.String),
  department: Schema.String,
  managerEmail: Schema.NullOr(Schema.String),
  managerName: Schema.NullOr(Schema.String),
  status: Schema.Literals(["active", "suspended", "archived", "inactive"]),
  navigatorUserId: Schema.NullOr(Schema.String),
  navigatorName: Schema.NullOr(Schema.String),
  navigatorNameUnique: Schema.optional(Schema.Boolean),
});
export type CareNavigationRosterMember = typeof CareNavigationRosterMember.Type;

export const CareNavigationRosterResponse = Schema.Struct({
  syncedAt: Schema.String,
  members: Schema.Array(CareNavigationRosterMember),
  unmatchedNavigatorNames: Schema.Array(Schema.String),
});
export type CareNavigationRosterResponse = typeof CareNavigationRosterResponse.Type;
